import moment from "moment-timezone";

export function changeLocale(locale = I18n.defaultLocale) {
  I18n.locale = locale;
  const momentLocale = locale === "zh" ? "zh-cn" : locale;
  moment.locale(momentLocale);
}
